module.exports = __webpack_public_path__ + "static/22-671c6b178869f8d75446114866233d7e.jpg";